import { render } from "./PreviewSection.vue?vue&type=template&id=b51fac38&scoped=true&ts=true"
import script from "./PreviewSection.vue?vue&type=script&lang=ts"
export * from "./PreviewSection.vue?vue&type=script&lang=ts"

import "./PreviewSection.vue?vue&type=style&index=0&id=b51fac38&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src129899678/src/web-ext-ai-voucher-humelo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b51fac38"]])

export default __exports__